import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  groupActionsCache: [], // TODO: refactor to cache by automation actions
  fetchingGroupActionsByAutomationActionIds: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
